<template>
  <v-card>
    <v-card-title class="pr-2" :style=" { backgroundColor: companyPrimaryColor }">
      <h2 style="color:white">Algemene instellingen barometers</h2>
      <v-spacer></v-spacer>
      <v-btn icon dark @click="closeBarometerCompanySettingsDialog()">
        <v-icon dark color="white">close</v-icon>
      </v-btn>
    </v-card-title>

    <v-alert class="ma-0 pa-2" v-if="feedback" :value="true" type="warning">{{ feedback }}</v-alert>

    <v-divider></v-divider>

    <v-card-text>
      <v-form ref="barometerSettingsForm" lazy-validation>
        <v-container grid-list-md>
          <v-layout row wrap>
            <v-flex xs12>
              <div class="barometer-item-setting-wrapper">
                <h2>Algemene instellingen</h2>
                <div style="margin: 0 0 20px 0">
                  <v-select
                    class="mt-4"
                    :items="displayTypes"
                    item-text="name"
                    item-value="value"
                    v-model="activeCompData.barometersSettings.dataView"
                    outlined
                    hide-details
                    :color="companyPrimaryColor"
                    :item-color="companyPrimaryColor"
                    background-color="background"
                    label="Kies dataweergave"
                  ></v-select>
                </div>
                <v-switch
                  label="Allround gegevens weergeven"
                  :color="companyPrimaryColor"
                  v-model="activeCompData.barometersSettings.showAllround"
                  class="pa-0"
                  hide-details
                ></v-switch>
                <v-switch
                  label="Dyflexis koppeling gebruiken"
                  :color="companyPrimaryColor"
                  v-model="activeCompData.barometersSettings.dyflexis"
                  class="pa-0"
                  hide-details
                ></v-switch>
                <v-switch
                  :color="companyPrimaryColor"
                  v-model="activeCompData.barometersSettings.showHourrateAmmount"
                  class="pa-0"
                  hide-details
                >
                  <template slot='label'>
                    <span style="color: #333; margin-right: 5px;">Uurnorm weergeven als bedrag </span>
                    <v-tooltip class="ma-0 pa-0" bottom >
                      <template v-slot:activator="{on}">
                        <v-icon color="#ccc" v-on="on">help</v-icon>
                      </template>
                      <span style="color: #fff;">Standaard wordt de uurnorm als percentage weergegeven.</span>
                    </v-tooltip>
                  </template>
                </v-switch>
                <v-switch
                  label="Barometer voor medewerkers weergeven"
                  :color="companyPrimaryColor"
                  v-model="activeCompData.barometersSettings.showEmployeeBarometer"
                  class="pa-0"
                  hide-details
                ></v-switch>
                <v-switch
                  label="Medewerkers Barometers alleen tonen aan Managers en Eigenaar"
                  :color="companyPrimaryColor"
                  v-model="activeCompData.barometersSettings.showEmployeeBarometerOnlyToManager"
                  class="pa-0"
                  hide-details
                ></v-switch>
                
              </div>
            </v-flex>
            <v-flex xs6>
              <div class="barometer-item-setting-wrapper">
                <h2>Barometers</h2>

                <v-switch
                  label="Maandelijkse / 4 wekelijks doel weergeven"
                  :color="companyPrimaryColor"
                  v-model="activeCompData.barometersSettings.showMonthBarometer"
                  class="pa-0"
                  hide-details
                ></v-switch>
                <v-switch
                  label="Wekelijks doel weergeven"
                  :color="companyPrimaryColor"
                  v-model="activeCompData.barometersSettings.showWeekGoalBarometer"
                  class="pa-0"
                  hide-details
                ></v-switch>
                <v-switch
                  label="Doel behandelingen weergeven"
                  :color="companyPrimaryColor"
                  v-model="activeCompData.barometersSettings.showWeekGoalTreatmentsBarometer"
                  class="pa-0"
                  hide-details
                ></v-switch>

                <v-switch
                  label="Aantal afspraken"
                  :color="companyPrimaryColor"
                  v-model="activeCompData.barometersSettings.showAppointments"
                  class="pa-0"
                  hide-details
                ></v-switch>

                <v-switch
                  :color="companyPrimaryColor"
                  v-model="activeCompData.barometersSettings.showWeekGoalProductsBarometer"
                  class="pa-0"
                  hide-details
                >
                  <template slot='label'>
                    <span style="color: #333; margin-right: 5px;">Productverkoop weergeven</span>
                    <v-tooltip class="ma-0 pa-0" bottom >
                      <template v-slot:activator="{on}">
                        <v-icon color="#ccc" v-on="on">help</v-icon>
                      </template>
                      <span style="color: #fff;">Per salon het gewenste percentage t.o.v. productomzet van vorig jaar invoeren.</span>
                    </v-tooltip>
                  </template>
                </v-switch> 
                       
                <v-switch
                  :color="companyPrimaryColor"
                  v-model="activeCompData.barometersSettings.useRevenuePercentageForProducts"
                  class="pa-0"
                  hide-details
                >
                  <template slot='label'>
                    <span style="color: #333; margin-right: 5px;">Productverkoop koppelen aan totale omzet </span>
                    <v-tooltip class="ma-0 pa-0" bottom >
                      <template v-slot:activator="{on}">
                      <v-icon color="#ccc" v-on="on">help</v-icon>
                      </template>
                      <span style="color: #fff;">Per salon het gewenste percentage van totale omzet invoeren.</span>
                    </v-tooltip>
                  </template>
                </v-switch> 
                  
                <v-switch
                  label="Kleuringen weergeven"
                  :color="companyPrimaryColor"
                  v-model="activeCompData.barometersSettings.showWeekGoalColorsBarometer"
                  value
                  input-value="true"
                  class="pa-0"
                  hide-details
                >
                </v-switch>

                <v-switch
                  label="Creativiteitsbarometer weergeven"
                  :color="companyPrimaryColor"
                  v-model="activeCompData.barometersSettings.showCreativeBarometer"
                  value
                  input-value="true"
                  class="pa-0"
                  hide-details
                ></v-switch>
                <v-switch
                  label="Gemiddelde omzet per klant weergeven"
                  :color="companyPrimaryColor"
                  v-model="activeCompData.barometersSettings.showRevenuePerTicketBarometer"
                  value
                  input-value="true"
                  class="pa-0"
                  hide-details
                ></v-switch>
              </div>
            </v-flex>

            <v-flex xs6>
              <div class="barometer-item-setting-wrapper">
                <h2>Barometers Medewerkers</h2>

                <v-switch
                  label="Maandelijkse / 4 wekelijks doel weergeven"
                  :color="companyPrimaryColor"
                  v-model="activeCompData.barometersSettings.showFourWeekBarometer"
                  class="pa-0"
                  hide-details
                ></v-switch>

                <v-switch
                  label="Aantal verkochte producten weergeven"
                  :color="companyPrimaryColor"
                  v-model="activeCompData.barometersSettings.showSoldProducts"
                  class="pa-0"
                  hide-details
                ></v-switch>

                <v-switch
                  label="Producten in percentage weergeven"
                  :color="companyPrimaryColor"
                  v-model="activeCompData.barometersSettings.showProductEmployee"
                  class="pa-0"
                  hide-details
                ></v-switch>

                <v-switch
                  label="Productiviteit weergeven"
                  :color="companyPrimaryColor"
                  v-model="activeCompData.barometersSettings.showProductivityEmployee"
                  class="pa-0"
                  hide-details
                ></v-switch>

                <v-switch
                  label="Omzet per uur weergeven"
                  :color="companyPrimaryColor"
                  v-model="activeCompData.barometersSettings.showRevenuePerHourEmployee"
                  class="pa-0"
                  hide-details
                ></v-switch>
                <v-switch
                  v-if="activeCompData.barometersSettings.dyflexis"
                  label="Dyflexis omzet per uur weergeven"
                  :color="companyPrimaryColor"
                  v-model="activeCompData.barometersSettings.showRevenuePerHourEmployeeDyflexis"
                  class="pa-0"
                  hide-details
                ></v-switch>
              </div>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </v-card-text>

    <v-divider></v-divider>

    <v-card-actions>
      <v-container grid-list-md fluid class="ma-0 pa-0">
        <v-layout row wrap class="ma-0 pa-0">
          <v-flex xs12 md6 class="text-left" v-if="$vuetify.breakpoint.name != 'sm' && $vuetify.breakpoint.name != 'xs'">
            <v-btn
              outlined
              depressed
              color="#8B93A6"
              @click="closeBarometerCompanySettingsDialog()"
              >
              Annuleren
            </v-btn>
          </v-flex>
          <v-flex xs12 md6 class="text-right">
            <v-btn
              :disabled=" !changed" 
              :depressed="!changed"  
              :dark=" changed"
              :block="$vuetify.breakpoint.name == 'sm' || $vuetify.breakpoint.name == 'xs'"
              rounded 
              :color="companySecondaryColor" 
              @click="saveSettings()"
              >
              Wijzigingen opslaan
              <v-icon right dark>chevron_right</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-actions>

  </v-card>
</template>


<script>
import db from "../../firebase/init";
import firebase from "firebase/app";;
import lodash from "lodash";
import platform from 'platform'; 

export default {
  name: "edit-barometer-company-settings-form",
  props: {
    activeCompData: Object,
    activeCompDataOriginal: Object
  },
  data() {
    return {
      feedback: null,
      displayTypes: [
        {
          name: "4 weken weergave",
          value: "fourweeks"
        },
        {
          name: "Maandweergave",
          value: "monthly"
        }
      ],
      errors: []
    };
  },

  methods: {
    closeBarometerCompanySettingsDialog() {
      this.$emit("editBarometerCompanySettingsDialogChange", false);
      this.feedback = null;
    },

    

    saveSettings() {
      let barometersSettings = this.activeCompData.barometersSettings

      db.collection("companies")
        .doc(this.activeCompData.id)
        .update({barometersSettings})
        // .update({
        //   barometersSettings: {
        //     dataView: this.activeCompData.barometersSettings.dataView,
        //     showAllround: this.activeCompData.barometersSettings.showAllround,
        //     showHourrateAmmount: this.activeCompData.barometersSettings
        //       .showHourrateAmmount,
        //     showCreativeBarometer: this.activeCompData.barometersSettings
        //       .showCreativeBarometer,
        //     showMonthBarometer: this.activeCompData.barometersSettings
        //       .showMonthBarometer,
        //     showWeekGoalBarometer: this.activeCompData.barometersSettings
        //       .showWeekGoalBarometer,
        //     showWeekGoalTreatmentsBarometer: this.activeCompData
        //       .barometersSettings.showWeekGoalTreatmentsBarometer,
        //     showWeekGoalProductsBarometer: this.activeCompData
        //       .barometersSettings.showWeekGoalProductsBarometer,
        //     showWeekGoalColorsBarometer: this.activeCompData.barometersSettings
        //       .showWeekGoalColorsBarometer,
        //     showEmployeeBarometer: this.activeCompData.barometersSettings
        //       .showEmployeeBarometer,
        //     showFourWeekBarometer: this.activeCompData.barometersSettings
        //       .showFourWeekBarometer,
        //     showSoldProducts: this.activeCompData.barometersSettings
        //       .showSoldProducts,
        //     showProductEmployee: this.activeCompData.barometersSettings
        //       .showProductEmployee,
        //     showProductivityEmployee: this.activeCompData.barometersSettings
        //       .showProductivityEmployee,
        //     showRevenuePerHourEmployee: this.activeCompData.barometersSettings
        //       .showRevenuePerHourEmployee
        //   }
        // })
        .then(() => {
          db.collection("log")
            .add({
              time: new Date(),
              logType: "info",
              user: this.userFirstName + " " + this.userLastName,
              userType: this.userRole,
              company: this.userCompany,
              actionType: "User Action",
              action:
                "Algemene barometer instellingen gewijzigd: " +
                this.activeCompDataOriginal.name,
              extra:
                "<b>ORIGINELE GEGEVENS</b> " +
                "<br>" +
                "<b>Dataweergave:</b> " +
                this.activeCompDataOriginal.barometersSettings.dataView +
                "<br><br>" +
                "<b>Allround gegevens weergeven:</b> " +
                this.activeCompDataOriginal.barometersSettings.showAllround +
                "<br><br>" +
                "<b>Uurnorm weergeven als bedrag:</b> " +
                this.activeCompDataOriginal.barometersSettings
                  .showHourrateAmmount +
                "<br><br><br>" +
                "<b>AANGEPAST GEGEVENS</b> " +
                "<br>" +
                "<b>Dataweergave:</b> " +
                this.activeCompData.barometersSettings.dataView +
                "<br><br>" +
                "<b>Allround gegevens weergeven:</b> " +
                this.activeCompData.barometersSettings.showAllround +
                "<br><br>" +
                "<b>Uurnorm weergeven als bedrag:</b> " +
                this.activeCompDataOriginal.barometersSettings
                  .showHourrateAmmount
            })
            .catch(error => {
              console.error("Error logging barometer settings: ", error);
            });
        })
        .then(() => {
          this.$emit("updateData");
          this.closeBarometerCompanySettingsDialog();
        })
        .catch(error => {
          console.error("Error updating Algemene Barometer Settings: ", error);
          db.collection("log").add({
            time: new Date(),
            logType: "error",
            user: this.userFirstName + " " + this.userLastName,
            userType: this.userRole,
            company: this.userCompany,
            actionType: "User Action",
            software: String(platform.os),
            browser: platform.name + ' ' + platform.version, 
            pillarrrVersion: this.$store.state.version,
            action:
              "Error updating Algemene Barometer Settings: " +
              this.activeCompData.name,
            extra: JSON.stringify(error)
          });
        });
    }
  },

  computed: {
    userCompanies() {
      return this.$store.state.userCompanies;
    },
    userCompany() {
      return this.$store.state.userCompany;
    },
    userFirstName() {
      return this.$store.state.userFirstName;
    },
    userLastName() {
      return this.$store.state.userLastName;
    },
    userRole() {
      return this.$store.state.userRole;
    },
    companyPrimaryColor() {
      return this.$store.state.companyPrimaryColor;
    },
    companySecondaryColor() {
      return this.$store.state.companySecondaryColor;
    },
    changed() {
      if (
        _.isEqual(
          this.activeCompData.barometersSettings,
          this.activeCompDataOriginal.barometersSettings
        ) == false
      ) {
        return true;
      } else {
        return false;
      }
    }
  }
};
</script>
